import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { sysInfo } from '@/config'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'registerResult', 'bigScreen'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log('to', to)
  console.log('from', from)
  console.log('next', next)
  // debugger
  const homePage = '/homePage'
  // NProgress.start() // start progress bar

  if (Vue.ls.get(ACCESS_TOKEN) && to.path !== '/user/login') {
    if (store.getters.roles.length === 0) {
      store.dispatch('GetInfo')
        .then(res => {
          store.dispatch('GenerateRoutes').then(() => {
            // 把已获取到的路由菜单加入到路由表中
            console.log('addRouters', store.getters.addRouters)
            router.addRoutes(store.getters.addRouters)
            if (from.path === '/user/login') {
              next({ path: homePage })
            } else {
              next({ ...to, replace: true })
            }
          })
        })
        .catch((err) => {
          console.log('err', err)
          store.dispatch('Logout').then(() => {
            if (!sysInfo.ifDebug) {
              location.href = sysInfo.loginURl
            } else {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            }
          })
        })
    } else {
      next()
      // }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      if (!sysInfo.ifDebug) {
        location.href = sysInfo.loginURl
      } else {
        next({
          path: '/user/login' // 无登录状态,先跳转到登录页面
          // query: { redirect: to.fullPath } // 登录成功后跳转回到该路由
        })
      }
      // NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles
    const elVal = vnode.context.$route.meta.permission
    const permissionId = elVal instanceof String && [elVal] || elVal
    roles.permissions.forEach(p => {
      if (!permissionId.includes(p.permissionId)) {
        return
      }
      if (p.actionList && !p.actionList.includes(actionName)) {
        el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
      }
    })
  }
})

export {
  action
}
